<template>
  <v-card>
    <v-card-title
      >MODIFICA DATI AZIENDA<v-spacer></v-spacer>
      <v-hover close-delay="500" open-delay="200" v-slot="{ hover }">
        <span>
          <span v-if="hover" color="gray lighten-1">Personalizza</span>
          <v-btn
            class="mx-2 align-right"
            fab
            small
            color="primary"
            :to="{ name: 'customize' }"
          >
            <v-icon> mdi-palette </v-icon>
          </v-btn>
        </span>
      </v-hover>
    </v-card-title>
    <v-card-text>
      <div class="pa-9">
        <v-row> </v-row>
        <v-row>
          <div
            elevation="5"
            class="company-logo grey lighten-2 ma-3"
            style="
              border: 1px solid #333;
              display: inline-block;
              width: 150px;
              height: 150px;
            "
          >
            <v-img
              v-if="CompanyData.logo"
              @click="imgLogo_Click"
              max-height="150"
              max-width="150"
              :src="
                loadingLogo ? '@/img/defaultcompanylogo.png' : CompanyData.logo
              "
              to="dashboard"
              lazy-src="@/img/defaultcompanylogo.png"
              contain
              style="margin: 0; padding: 0; margin-right: 5px"
            ></v-img>
          </div>
          <v-file-input
            loading="loadingLogo"
            ref="finput"
            v-model="fileLogo"
            @change="logo_Selected"
            :rules="rules"
            label="Logo (150x150px)"
            :show-size="true"
            outlined
            persistent-placeholder
            accept="image/png, image/jpeg, image/bmp"
            :placeholder="
              CompanyData.logo ? CompanyData.logo : 'Seleziona un logo'
            "
            prepend-icon="mdi-image"
          >
          </v-file-input>
        </v-row>
        <v-row>
          <v-col cols="6" style="margin-bottom: 0.5vh">
            <v-text-field
              ref="input"
              label="Ragione Sociale"
              type="text"
              v-model="CompanyData.ragioneSociale"
              filled
            ></v-text-field>
          </v-col>

          <v-col cols="6" style="margin-bottom: 1vh">
            <v-text-field
              ref="input"
              label="Partita IVA"
              filled
              v-model="CompanyData.partitaIva"
              type="text"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" style="margin-bottom: 1vh">
            <v-text-field
              ref="input"
              v-model="CompanyData.indirizzo"
              label="indirizzo"
              filled
              type="text"
            ></v-text-field>
          </v-col>

          <v-col cols="6" style="margin-bottom: 1vh">
            <v-text-field
              ref="input"
              v-model="CompanyData.telefono"
              label="telefono"
              filled
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4" style="margin-bottom: 1vh">
            <v-text-field
              ref="input"
              v-model="CompanyData.citta"
              label="Città"
              filled
              type="text"
            ></v-text-field>
          </v-col>

          <v-col cols="4" style="margin-bottom: 1vh">
            <v-text-field
              ref="input"
              v-model="CompanyData.provincia"
              label="Provincia"
              filled
              type="text"
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn large class="btnLogin" color="primary" @click="submitCompany">
        Salva le modifiche
        <template v-slot:loader>
          <span>Saving...</span>
        </template>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style lang="scss"></style>

<script>
import EasyPlanClient from "../../utils/EasyPlanClient";
import SessionHelper from "@/utils/SessionHelper";
export default {
  data() {
    return {
      rules: [
        (value) =>
          !value ||
          value.size < 2000000 ||
          "Logo size should be less than 2 MB!",
      ],
      fileLogo: null,
      error: "",
      loadingLogo: false,
      CompanyData: {
        ragioneSociale: "",
        partitaIVA: "",
        indirizzo: "",
        cap: "",
        citta: "",
        provincia: "",
        telefono: "",
      },
      loader: null,
    };
  },
  methods: {
    imgLogo_Click() {
      console.debug("i'm doing click");
      this.$refs.finput.$el.click();
    },
    getBase64(file, onRead, onError) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        onRead(reader);
      };

      reader.onerror = function (error) {
        onError(error);
      };
    },
    async logo_Selected() {
      this.loadingLogo = true;
      await this.getBase64(
        this.fileLogo,
        (reader) => {
          let logoBase64 = reader.result;
          console.debug("logoBase64", logoBase64);
          EasyPlanClient.Company.UpdateLogo(
            this.$route.params.companyAlias,
            this.fileLogo.name,
            logoBase64
          )
            .then((res) => {
              console.debug("companylogo updated", res);

              setTimeout(() => {
                this.loadingLogo = false;

                SessionHelper.loadCompanyInfo(
                  this.$route.params.companyAlias,
                  () => {
                    location.reload();
                  }
                );
                this.loadCompanyInfo();
              }, 1000);
            })
            .catch((error) => {
              this.loadingLogo = false;
              console.log(error);
              this.error = EasyPlanClient.GetErrorDescription(
                error.response.data.errorCode
              );
              console.error(
                "si è verificato un errore (" +
                  error.response.data.errorCode +
                  ")" +
                  this.error
              );
              console.error(error);
            });
        },
        (error) => {
          console.info("ERROR", error);
        }
      );
    },
    loadCompanyInfo() {
      console.debug("carico companyInfo");
      EasyPlanClient.Company.FindByAlias(this.$route.params.companyAlias)
        .then((res) => {
          console.debug(res);
          this.CompanyData = res.data.data;
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
    submitCompany: function () {
      if (
        !this.CompanyData.ragioneSociale.length > 0 &&
        this.CompanyData.partitaIVA.length > 0
      ) {
        this.error = "Inserisci  i dati dell'azienda per proseguire";
        return "";
      }
      EasyPlanClient.Company.UpdateCompany(
        this.CompanyData.alias,
        this.CompanyData.ragioneSociale,
        this.CompanyData.partitaIva,
        this.CompanyData.indirizzo,
        this.CompanyData.cap,
        this.CompanyData.citta,
        this.CompanyData.provincia,
        this.CompanyData.telefono
      )
        .then((res) => {
          console.debug("risposta add company:");
          console.debug(res);
          let companyAlias = res.data.data;

          this.$router.push({
            name: "login",
            params: { companyAlias: companyAlias },
          });
        })
        .catch((error) => {
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error("si è verificato un errore" + this.error);
          console.error(error);
        });
    },
  },
  computed: {
    loaing: {
      get() {
        return this.loader.length > 0;
      },
    },
    ShowSnackbar: {
      get() {
        return this.error.length > 0;
      },
      set(value) {
        if (!value) this.error = "";
      },
    },
  },
  mounted() {
    this.loadCompanyInfo();
  },
  created: function () {
    // if (
    //   localStorage.userToken != undefined &&
    //   localStorage.userToken != "null"
    // ) {
    //   EasyPlanClient.SetJWT(localStorage.userToken);
    // }
    // this.loadCompanyInfo();

    if (
      localStorage.userToken == undefined ||
      localStorage.userToken == "null"
    ) {
      console.debug("logging off");
      localStorage.userToken = null;

      this.$router.push({
        name: "login",
        params: { companyAlias: this.$route.params.companyAlias },
      });
    }
  },
};
</script>
